import * as globals from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled, {css} from 'styled-components';

import {Skeleton} from '../../../../../../components/Skeleton';

const planCardCSS = css`
  min-width: 330px;
  width: 50%;
  display: flex;
  flex-direction: column;
  max-width: none;
  border-radius: 8px;
  :not(:last-child) {
    margin-right: 12px;
  }
`;

export const PlanCardWrapper = styled.div`
  border: solid 1px ${globals.MOON_200};
  justify-content: space-between;
  background-color: ${globals.white};
  padding: 24px;

  ${planCardCSS}
`;

export const TextSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LoadingPlanCard = styled(Skeleton)`
  height: 200px;
  ${planCardCSS}
`;

export const PlanTitle = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 34px;
  color: ${globals.gray800};
`;

export const SubtitleWrapper = styled.div``;

export const DescriptionWrapper = styled.div`
  margin-bottom: 12px;
`;

export const CallToActionWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
